import React from 'react';
import ReactDOM from 'react-dom/client';

import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { CssBaseline, ThemeProvider } from '@mui/material';

import '@fontsource/poppins/200.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@services/i18n';
import './styles/App.scss';

import { ErrorBoundary } from '@shared/components';
import App from './App';
import theme from './theme';
import { startVersionCheck } from '@shared/utils/versionCheck';
import { installGlobalErrorHandlers } from '@shared/telemetry';

startVersionCheck();
installGlobalErrorHandlers();

const emotionCache = createCache({
  key: 'bg',
  prepend: true,
});

const appElement = document.getElementById('app');

if (!appElement) {
  throw new Error('Failed to find the root element with id "app"');
}

const root = ReactDOM.createRoot(appElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <CacheProvider value={emotionCache}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {window.self === window.top && <App />}
        </ThemeProvider>
      </CacheProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
